module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt20 ovh",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.brandList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "agreementCode",
      "label": "品牌品类申请编号",
      "min-width": "220",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "parentBrandAgreementCode",
      "label": "原品牌品类编号",
      "min-width": "220",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contractCode",
      "label": "合同编号",
      "min-width": "220",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合作期限",
      "min-width": "220",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("datetimes")(scope.row.startTime)) + " - " + _vm._s(_vm._f("datetimes")(scope.row.endTime)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusDesc",
      "label": "合作状态",
      "min-width": "220",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeDesc",
      "label": "申请类型",
      "min-width": "220",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": scope.row.type == 2 ? '/supplierBrandAgreement?agreementId=' + scope.row.agreementId : (scope.row.type == 3 ? '/supplierBrandSupplement?agreementId=' + scope.row.agreementId : '')
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("\n                        查看详情\n                    ")])], 1), _vm._v(" "), _c('span'), _vm._v(" "), (_vm.editAuth && (scope.row.status == 1 || scope.row.status == 4)) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.endBrandAgreement(scope.row.agreementId, scope.row.type)
            }
          }
        }, [_vm._v("\n                    终止合作\n                ")]) : _vm._e()]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbdea148"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierInfo/brandList.vue
// module id = 570
// module chunks = 0